import { useSessionStorage } from '@dhl/use-storage'

import { isFeatureEnabled } from '~/config/index.js'
import { useGetProfile } from '~/profile/model/profile/hooks.js'

const validateMobileNumberDismissedKey = 'portal-validate-mobile-number-dismissed'

export const useValidateMobileNumberInteraction = () => {
  const { refetch: getProfile } = useGetProfile({
    query: {
      enabled: false,
    },
  })
  const [dismissed] = useSessionStorage<boolean>(validateMobileNumberDismissedKey, false)

  return async (): Promise<boolean> => {
    try {
      if (!isFeatureEnabled('interaction.validateMobileNumber')) {
        return false
      }

      if (dismissed) {
        return false
      }

      const { data: profile } = await getProfile()

      return profile?.mobilePhone?.isValidationRequired ?? false
    } catch {
      return false
    }
  }
}
